import { Component, Input } from '@angular/core';
import { scaleConfig } from 'src/app/feature-modules/shared-module/range-scale/range-scale.config';
import { ScaleType } from 'src/app/feature-modules/shared-module/range-scale/range-scale.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { RangeScaleComponent } from 'src/app/feature-modules/shared-module/range-scale/range-scale.component';
import { WaterQualityStatus } from 'src/app/interface-model/app-interface-model';

@Component({
    selector: 'app-balance',
    templateUrl: './balance.component.html',
    styleUrls: ['./balance.component.css'],
    standalone: false
})
export class BalanceComponent {
  @Input() balanceDetails: any;

  scaleType = ScaleType;
  modalRef!: BsModalRef; 

  constructor(private modalService: BsModalService) { }

  openModal(type: ScaleType) {
      const initialState = scaleConfig[type];
      this.modalRef = this.modalService.show(RangeScaleComponent, {
        class: 'modal-lg',
        initialState
      });
    }

  getStatusIcon(value: any): string {
    const status = this.getpHStatus(value);
    switch (status) {
      case 'normal':
        return 'assets/img/normal-status.svg';
      case 'needsAttention':
        return 'assets/img/needs-attention.svg';
      case 'actionRequired':
        return 'assets/img/redWarning.svg';
      default:
        return '';
    }
  }

  getStatusLabel(value: number): string {
  return this.getpHStatus(value);
}

  // Helper: Determine pH level status
  getpHStatus(value: number): WaterQualityStatus {
    if (value < 7 || value > 7.8) return "actionRequired";
    if (value < 7.2 || value > 7.6) return "needsAttention";
    return "normal";
  };
}
